import { giftcardToken, isTokenValid } from '../../utils';
import api from '../../utils/axios';
import { baseURL, CLASERVER } from '../../utils/url';
export const Internal_Token = async (body) => {
  try {
    const fetchResponse = await fetch("https://apicustomerportalsaas.cladev.com/web/api/internaltoken", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await fetchResponse.json();
  } catch (error) {
    console.error('Internal_Token error:', error);
    throw error;
  }
};

export const ssoLogin = async (token, access_key) => {
  try {
    const response = await api.get(`Customer/GetCustomerFromAccessKey?accesskey=${access_key}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('ssoLogin error:', error.response?.data || error.message);
    throw error;
  }
};

export const customerView = async (token, data) => {
  try {
    const response = await api.get(`CustomerProfileData/${data}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('customerView error:', error.response?.data || error.message);
    throw error;
  }
};

export const getreferralData = async (token, merchantCode, customerid) => {
  try {
    const response = await api.get(`GetReferralData/${merchantCode}?customerid=${customerid}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('getreferralData error:', error.response?.data || error.message);
    throw error;
  }
};

export const getRewardData = async (token, merchantCode, value) => {
  try {
    const response = await api.get(`GetRewardDataByRange?merchantCode=${merchantCode}&value=${value}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('getRewardData error:', error.response?.data || error.message);
    throw error;
  }
};

export const AddReferralData = async (token, data) => {
  try {
    const response = await api.post('AddRefferalData/MER000325', data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('AddReferralData error:', error.response?.data || error.message);
    throw error;
  }
};


export const transaction = async (token, data) => {
  try {
    const response = await api.post('Transaction/TransactionManager', data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('transaction error:', error.response?.data || error.message);
    throw error;
  }
};

export const getQualifiedCamp = async (token, customerCode) => {
  try {
    const response = await api.get(`GetAllQualifiedCampaignByCustomerCode?customercode=${customerCode}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('getQualifiedCamp error:', error.response?.data || error.message);
    throw error;
  }
};

export const getMilestone = async (token, companyid) => {
  try {
    const response = await api.get(`GetEarningMilestones?companyid=${companyid}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('getMilestone error:', error.response?.data || error.message);
    throw error;
  }
};

export const milestone = async (token, data) => {
  try {
    const response = await api.post('PostEarningMilestone?merchantCode=MER000325', data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('milestone error:', error.response?.data || error.message);
    throw error;
  }
};

export const fulfilmentToken = async (body) => {
  try {
    const fetchResponse = await fetch(`https://apicustomerportalsaas.cladev.com/web/api/fulfilmentToken`, {
      method: "POST",
      headers: {
        Authorization: "Bearer ",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await fetchResponse.json();
  } catch (error) {
    return error;
  }
};

export const getCustomerGiftcard = async (token, merchant_code, country) => {
  token = await giftcardToken();
  if (!token || !isTokenValid(token)) {
    return { error: "Token is expired and could not be refreshed." };
  }

  try {
    const fetchResponse = await fetch(`https://apicustomerportalsaas.cladev.com/web/api/getCustomerGiftcard`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return await fetchResponse.json();
  } catch (error) {
    return error;
  }
};

export const transactionRedeem = async (token, data) => {
  try {
    const response = await api.post('Transaction/Redeem', data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error(error.response?.data || error.message);
    throw error.response?.data;
  }
};

export const fileUpload = async (token, file) => {
  const formData = new FormData();
  formData.append("imgUpload", file);
  try {
    const response = await api.post('FileUploadProcess2/test?eventFor=Receipt&isMultiple=false', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error.response?.data || error.message);
    throw error.response?.data;
  }
};


export const receiptFilePath = async (token, data) => {
  try {
    const response = await api.post(`${baseURL}receiptFilePath`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error(error.response?.data || error.message);
    throw error.response?.data;
  }
};

export const merchantSchema = async (token, id) => {
  try {
    const response = await api.get(`merchantschema?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('getMilestone error:', error.response?.data || error.message);
    throw error;
  }
};
